import InformationIndex from '../components/Information/Index'
import InformationDetail from '../components/Information/Detail'

export default [
  {
    path: '/client/informations',
    name: 'information-index',
    component: InformationIndex,
    meta: {
      sideMenuId: 'information',
    },
  },
  {
    path: '/client/informations/:id',
    name: 'information-detail',
    component: InformationDetail,
    props: true,
    meta: {
      sideMenuId: 'information',
    },
  },
]
